import { Box } from "@mui/system";
import SquareIcon from '@mui/icons-material/Square';
import React from "react";
import PropTypes from 'prop-types';
import './index.scss';
import { Tooltip, Typography } from "@mui/material";

const UpSellOpportunityGraph = (props: { minVal: any; maxVal: any; currentState: any; recState: any; avgVal: any; adjustPositionValue: any; }) => {
    const { minVal, maxVal, currentState, recState, avgVal, adjustPositionValue } = props;
   
    const numberFormatter = (num : any) => {
        if(num > 999 && num < 1000000){
            return (num/1000)?.toFixed(2) + 'K'; // convert to K for number from > 1000 < 1 million 
        }else if(num > 1000000){
            return (num/1000000)?.toFixed(2) + 'M'; // convert to M for number from > 1 million 
        }   
        
        return num; // if value < 1000, nothing to do
    }

    const calculateValue = (val: any) => Number(((val - minVal) * 100) / (maxVal - minVal));

    const calculatePosition = (newVal: any) => `calc(${newVal}% + (${7 - newVal * 0.15}px))`;

    const calculatePositionWithEqualMaxValue = (newVal: any) => `calc(${newVal}% + (${-5 - newVal * 0.15}px))`;

    const calculateDiamondIconValue = (val: any) => {
        if (val === maxVal) {
           return calculatePositionWithEqualMaxValue(calculateValue(val));
        } else if (val > maxVal || Math.trunc(val) === Math.trunc(maxVal)) {
            val = maxVal;
           return calculatePositionWithEqualMaxValue(calculateValue(val));
        } 
           return calculatePosition(calculateValue(val));
    } 

    return (
        <Box>
            <Box>
                <Typography style={{ height: '24px', backgroundColor: '#ffffff', width:'100%' }}>
                    <Tooltip title ={`$` + numberFormatter(currentState)}>
                        <Box sx={{
                            position: 'absolute', marginTop: '4px', marginBottom: '4px',
                            left: currentState === maxVal ? calculatePositionWithEqualMaxValue(calculateValue(currentState)) 
                            : `calc(${calculateValue(currentState)}% + (${7 - calculateValue(currentState) * 0.3}px))`
                        }}>
                            <SquareIcon x="0" y="0" sx={{ color: '#d50a0a', width: '15px', height: '15px' }} />
                        </Box>
                    </Tooltip>
                    <Tooltip title ={`$` + numberFormatter(avgVal)}>
                        <Box sx={{
                            borderLeft: '3px dotted black', height: '42px', position: 'absolute', marginLeft:avgVal === minVal ? '1%' : '', 
                            left: avgVal === maxVal ? calculatePositionWithEqualMaxValue(calculateValue(avgVal)) : calculatePosition(calculateValue(avgVal))
                        }} />
                    </Tooltip>

                    <Tooltip title={`$`+ numberFormatter(adjustPositionValue === 0 ? recState : adjustPositionValue)}>
                        <Box sx={{
                            position: 'absolute', marginTop: '4px', marginBottom: '4px',
                            left: calculateDiamondIconValue(adjustPositionValue === 0 ? recState : adjustPositionValue),
                        }}>
                            <SquareIcon x="0" y="0" sx={{ transform: 'rotate(45deg)', color: '#0097a9', width: '17px', height: '17px' }} />
                        </Box>
                    </Tooltip>

                    <Tooltip title={`$`+ numberFormatter(recState)}>
                        <Box sx={{
                            position: 'absolute', marginTop: '4px', marginBottom: '4px',
                            left: calculateDiamondIconValue(recState)
                        }}>
                            <SquareIcon x="0" y="0" sx={{ transform: 'rotate(45deg)', color: '#FFC72C', width: '15px', height: '15px' }} />
                        </Box>
                    </Tooltip>
                    
                </Typography>
            </Box>
            <Box>
                <Box sx={{ float: 'left', position: 'absolute', color: '#ffffff' }}>
                    ${numberFormatter(minVal)}
                </Box>

                <Box sx={{ float: 'right', color: '#ffffff' }}>
                    ${numberFormatter(maxVal)}
                </Box>
            </Box>    
        </Box>
    )
}

UpSellOpportunityGraph.propTypes = {
	minVal: PropTypes.number,
    maxVal: PropTypes.number,
    currentState: PropTypes.number,
    recState: PropTypes.number,
    avgVal: PropTypes.number
}

export default UpSellOpportunityGraph;